<template>
  <Nextgrid apiurl="VisionNextCustomer/api/CustomerTarget/Search" :andConditionalModel="model" />
</template>
<script>
export default {
  data () {
    let branchId = this.$store.state.BranchId
    return {
      model: {
        branchIds: [branchId]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/CustomerTarget/index.vue